import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useUserSettings } from "../../context/userSettingsContext";
import { useI18n } from "../../hooks/useTranslations";
import { useMaintenancesApi } from "../../http/maintenances/api";
import { UpsertMaintenance } from "../../http/maintenances/types";
import { convertLocalDateToUTC, convertMilesToKilometers } from "../../types/utils";
import ModalDialog from "../ui/ModalDialog";
import MaintenanceForm, { MaintenanceFormBody } from "./MaintenanceForm";

type CreateMaintenanceDialogProps = {
  carId?: string;
  onClose: (success?: boolean) => void;
};

const CreateMaintenanceDialog: FC<CreateMaintenanceDialogProps> = ({ carId, onClose }) => {
  const i18n = useI18n();
  const userSettings = useUserSettings();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const maintenancesApi = useMaintenancesApi();
  const distanceInMiles = !!userSettings.me.distanceInMiles;

  const onSubmit = async (data: MaintenanceFormBody) => {
    const distance =
      data.distance != undefined && distanceInMiles ? convertMilesToKilometers(data.distance) : data.distance;

    const body: UpsertMaintenance = {
      carId: carId ?? data.car?.id ?? "",
      date: convertLocalDateToUTC(data.date),
      typeId: data.type.id,
      description: data.description,
      distance,
      cost: data.cost,
    };

    setIsSubmitting(true);
    try {
      await maintenancesApi.insertAdminMaintenance(body);
      dispatch(showSuccessNotification(i18n.t));
      onClose(true);
    } catch (err) {
      dispatch(showErrorNotification(i18n, err));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <ModalDialog onClose={() => onClose()} title={i18n.t.maintenance.new}>
      <MaintenanceForm isDisabled={isSubmitting} onSubmit={onSubmit} allowSelectCar={!carId} />
    </ModalDialog>
  );
};

export default CreateMaintenanceDialog;
